<script setup lang="ts">
import { computed, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import SiteFooter from '@/components/SiteFooter.vue'
import SiteHeader from '@/components/SiteHeader.vue'
import { legalContent } from '@/data/site'

const route = useRoute()
const content = computed(() => legalContent[route.params.type as keyof typeof legalContent] ?? legalContent.privacy)

watchEffect(() => {
  document.title = `${content.value.title}｜Nova·云枢`
})
</script>

<template>
  <div class="light-page">
    <SiteHeader />
    <main class="legal-page">
      <div class="legal-shell">
        <RouterLink to="/" class="back-link">← 返回首页</RouterLink>
        <article>
          <h1>{{ content.title }}</h1>
          <p class="legal-intro">{{ content.intro }}</p>
          <section v-for="([title, body], index) in content.sections" :key="title">
            <h2>{{ index + 1 }}. {{ title }}</h2>
            <p>{{ body }}</p>
          </section>
          <p class="legal-date">最后更新日期：2026 年 8 月 20 日</p>
        </article>
      </div>
    </main>
    <SiteFooter />
  </div>
</template>
